export default "__VITE_ASSET__BiZ$REyL__"